import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const bookingsRoutes: Array<RouteConfig> = [
  {
    path: "bookings_list",
    name: "bookings_list",
    component: () => import("@/views/Bookings/BookingsList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  }
];

export default bookingsRoutes;